<template>
  <month-history-loads :loads="loadHistoryForMonth"
                       :company="company"
                       :loading="loadingLoadHistory"
                       :accurateSince="loadHistoryTimestamp"
                       @selectMonth="loadHistory($event)"
                       history>
  </month-history-loads>
</template>

<script>
import API from '@/api';
import MonthHistoryLoads from '@/components/dashboard/simple/MonthHistoryLoads';
import moment from 'moment';

export default {
  name: 'HistorySection',
  components: {
    MonthHistoryLoads,
  },
  props: {
    company: {
      type: Object,
    },
  },
  data: () => ({
    selectedMonthYear: null,
    loadingLoadHistory: false,
    loadHistoryTimestamp: null,
    loadHistoryForMonth: [],
  }),
  methods: {
    getBookedLoads() {
      this.$store.dispatch('bookedLoads/getBookedLoads', this.company.id);
    },
    async loadHistory(selectedMonthYear) {
      this.selectedMonthYear = selectedMonthYear;
      this.loadingLoadHistory = true;
      const monthHistory = await API.company.getLoadHistory({
        companyId: this.company.id,
        month: selectedMonthYear.monthIndex,
        year: selectedMonthYear.year,
      });
      this.loadHistoryForMonth = monthHistory.data.loads;
      this.loadHistoryTimestamp = moment();
      this.loadingLoadHistory = false;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Loads/HistorySection.vue